import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=620702b1&scoped=true&"
import script from "./ApplicationView.vue?vue&type=script&lang=js&"
export * from "./ApplicationView.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationView.vue?vue&type=style&index=0&id=620702b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620702b1",
  null
  
)

export default component.exports